import React from 'react';
import i18next from 'i18next';
import { Form, FormikProps, Field, withFormik, FormikBag } from 'formik';
import {
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  CardHeader,
  Row,
} from 'reactstrap';

import SubmitButtonWithLoader from '../common/SubmitButtonWithLoader';
import { ROLES } from 'enums';
import UserRoleSelect from './UserRoleSelect';

export type AddUserFormValues = {
  name: string;
  email: string;
  password: string;
  role_id: number;
  restaurant_id: number;
  create_restaurant_config: boolean;
};

interface AddUserFormOwnProps {
  isDriver?: boolean;
  restaurantId: number;
  onAddUser: (user: AddUserFormValues) => void;
}

type AddUserFormProps = AddUserFormOwnProps & FormikProps<AddUserFormValues>;

const AddUserFormWithoutFormik: React.FC<AddUserFormProps> = (props) => {
  const { isDriver, isSubmitting, handleChange, values } = props;
  return (
    <Card>
      <CardHeader>
        {isDriver ? i18next.t('add-user-form.title-driver') : i18next.t('add-user-form.title-user')}
      </CardHeader>
      <CardBody>
        <Form>
          <Row className="mx-0 d-flex flex-wrap">
            <FormGroup className="col min-w-200">
              <Label>{i18next.t('add-user-form.full-name')}</Label>
              <Field as={Input} name="name" placeholder={i18next.t('add-user-form.name-placeholder')} />
            </FormGroup>
            <FormGroup className="col min-w-200">
              <Label>{i18next.t('add-user-form.email')}</Label>
              <Field as={Input} name="email" />
            </FormGroup>
            <FormGroup className="col min-w-200">
              <Label>{i18next.t('add-user-form.phone')}</Label>
              <Field as={Input} name="phone" />
            </FormGroup>
            <FormGroup className="col min-w-200">
              <Label>{i18next.t('add-user-form.password')}</Label>
              <Field as={Input} name="password" />
            </FormGroup>
            {!isDriver && (
              <UserRoleSelect
                name={'role_id'}
                onChange={handleChange}
                value={values.role_id}
              />
            )}
            {!isDriver && (
              <FormGroup className="col min-w-200">
                <Label className="ml-3">
                  <Input
                    type="checkbox"
                    name={'create_restaurant_config'}
                    onChange={handleChange}
                    checked={values.create_restaurant_config}
                  />
                  {i18next.t('add-user-form.create-restaurant-config')}
                  <br />
                  {i18next.t('add-user-form.create-restaurant-config-hint')}
                </Label>
              </FormGroup>
            )}
          </Row>
          <FormGroup className="col-12">
            <SubmitButtonWithLoader
              label={isDriver ? i18next.t('add-user-form.submit-driver') : i18next.t('add-user-form.submit-user')}
              loading={isSubmitting}
            />
          </FormGroup>
        </Form>
      </CardBody>
    </Card>
  );
};

const AddUserForm = withFormik<AddUserFormOwnProps, AddUserFormValues>({
  mapPropsToValues: (props: AddUserFormOwnProps) => ({
    name: '',
    email: '',
    password: '',
    role_id: props.isDriver ? ROLES.RESTAURANT_DRIVER : ROLES.RESTAURANT_ADMIN,
    restaurant_id: props.restaurantId,
    create_restaurant_config: false,
  }),
  handleSubmit: (
    values: AddUserFormValues,
    { props, setSubmitting }: FormikBag<AddUserFormOwnProps, AddUserFormValues>
  ) => {
    return props.onAddUser(values);
  },
})(AddUserFormWithoutFormik);

export default AddUserForm;
